var _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFormulaSheetpen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 6C6.6 6.4585 7.04 7.5 8 8M8 8C8.96 7.5 9.4 6.4585 9.5 6M8 8V10.5M9.25 9H6.75",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.25 10.5H4.3635C2.7335 10.5 1.9175 10.5 1.3515 10.101C1.19042 9.98804 1.04645 9.85248 0.924 9.6985C0.5 9.1655 0.5 8.3985 0.5 6.8635V5.591C0.5 4.1095 0.5 3.3685 0.7345 2.777C1.1115 1.8255 1.9085 1.0755 2.9195 0.7205C3.5475 0.5 4.334 0.5 5.909 0.5C6.808 0.5 7.258 0.5 7.617 0.626C8.1945 0.829 8.65 1.2575 8.8655 1.801C9 2.139 9 2.5625 9 3.409V4.25",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 5.5C0.5 5.05802 0.675577 4.63414 0.988107 4.32161C1.30064 4.00908 1.72452 3.8335 2.1665 3.8335C2.4995 3.8335 2.892 3.8915 3.2155 3.805C3.35685 3.76696 3.48572 3.69243 3.58919 3.58887C3.69265 3.48532 3.76708 3.35639 3.805 3.215C3.8915 2.8915 3.8335 2.499 3.8335 2.166C3.83363 1.7241 4.00927 1.30035 4.32178 0.98793C4.6343 0.675508 5.0581 0.5 5.5 0.5",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFormulaSheetpen);
export default __webpack_public_path__ + "static/media/formulaSheetpen.d4ee2ecd4dc8132fae60775445ed4c5b.svg";
export { ForwardRef as ReactComponent };